import get from 'lodash/get';

import ParamsService from '@/utils/ParamsService';
import { flattenPreserveArrays, filterArraysFromPreviousStepData, convertSimpleTypeArrayToObjectArray } from '@/utils/helpers';

/* Private */

function selectedNodeUUID(selectedSource) {
	return ParamsService.extractNodeUUIDFromValue(selectedSource);
}

function selectedSourceObjectName(selectedSource, insertDataReplaceDict, configurationsMappingBlocksUUIDs) {
	return ParamsService.extractPathFromValue(selectedSource, insertDataReplaceDict, configurationsMappingBlocksUUIDs);
}

/* Public */

function sourceDataForDataInputMenu(selectedSource, getNodeByUuidForSelectedWorkflowVersion, getAction) {
	const nodeUUID = selectedNodeUUID(selectedSource);
	if (!nodeUUID) {
		return {};
	}
	const sourceNode = getNodeByUuidForSelectedWorkflowVersion(nodeUUID);
	if (!sourceNode) {
		return {};
	}
	let isDynamic = false;
	const userSchemaMappingsSourceFieldUuid = sourceNode.user_schema_mappings_source_field_uuid;
	if (userSchemaMappingsSourceFieldUuid) {
		const action = getAction(sourceNode.action);
		if (action?.has_user_schema) {
			isDynamic = true;
			return {
				isDynamic,
				userSchemaMappingsSourceFieldUuid,
				sourceTableServiceId: sourceNode.service,
				sourceTableActionId: sourceNode.action,
			};
		}
	}
	return { isDynamic };
}

function rowsFromPreviousSteps(
	selectedSource,
	getPreviousStepDataForNodeByUUID,
	insertDataReplaceDict = {},
	configurationsMappingBlocksUUIDs
) {
	const nodeUUID = selectedNodeUUID(selectedSource);
	if (!nodeUUID) {
		return [];
	}
	const previousStepData = getPreviousStepDataForNodeByUUID(nodeUUID);
	const sourceObjectName = selectedSourceObjectName(selectedSource, insertDataReplaceDict, configurationsMappingBlocksUUIDs);
	return convertSimpleTypeArrayToObjectArray(filterArraysFromPreviousStepData(previousStepData)[sourceObjectName]);
}

function columnDefsFromPreviousSteps(rowsFromPreviousSteps, shouldFlatten) {
	const fields = {};
	const fieldsList = [];
	for (const row of rowsFromPreviousSteps) {
		for (const columnName of Object.keys(shouldFlatten ? flattenPreserveArrays(row) : row)) {
			if (!fields[columnName]) {
				fields[columnName] = true;
				fieldsList.push({ field: columnName, headerName: columnName, exampleData: get(row, columnName), minWidth: 100 });
			}
		}
	}
	return fieldsList;
}

function setSideBarTableViewContent(rowsFromPreviousSteps, title, setTableContent) {
	setTableContent({
		title,
		data: {
			rowsFromPreviousSteps,
			columnDefsFromPreviousSteps: TableActionEditorService.columnDefsFromPreviousSteps(rowsFromPreviousSteps),
		},
	});
}

const DEFAULT_TABLE_PAGE_SIZE = 5;
const pageSizeItems = [
	{ text: String(DEFAULT_TABLE_PAGE_SIZE), value: DEFAULT_TABLE_PAGE_SIZE },
	{ text: '10', value: 10 },
	{ text: '15', value: 15 },
	{ text: 'All', value: 999999999 },
];

const DEFAULT_TABLE_COLUMN_ORDER = 'original';
const TABLE_COLUMN_ORDER_CUSTOM = 'custom';
const columnOrderItems = [
	{ text: 'Original order in table', value: DEFAULT_TABLE_COLUMN_ORDER },
	{ text: 'Order selected above', value: TABLE_COLUMN_ORDER_CUSTOM },
];

const TableActionEditorService = {
	DEFAULT_TABLE_PAGE_SIZE,
	DEFAULT_TABLE_COLUMN_ORDER,
	TABLE_COLUMN_ORDER_CUSTOM,
	pageSizeItems,
	rowsFromPreviousSteps,
	columnDefsFromPreviousSteps,
	setSideBarTableViewContent,
	sourceDataForDataInputMenu,
	columnOrderItems,
};

export default TableActionEditorService;
